import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  updateJobAlertCreateDialog,
  updateJobAlertCreateDialogWithKeyword,
  updateVisitorJobAlertDialogDetails,
  updateVisitorJobAlertDialogOrigin,
} from "../../../redux/actions/dialog_action";
import {
  updateJobAlertEmail,
  updateShowJobAlertDialog,
} from "../../../redux/actions/job_action";
import {
  AlertContainer,
  BellIconStyled,
  BoxStyled,
  ButtonStyled,
  CloseIconStyled,
  EnvelopeIconStyled,
  InputAdornmentStyled,
  InputBaseStyled,
  TextStyled,
} from "./styles";

function JobAlertSticky(props) {
  const dispatch: any = useDispatch();
  const [email, setEmail] = useState("");
  const [hideContainer, sethideContainer] = useState(false);

  const title = props.job.title;

  function onInputUpdate(event) {
    setEmail(event.target.value);
    dispatch(
      updateVisitorJobAlertDialogDetails({
        email: event.target.value,
      })
    );
    dispatch(updateJobAlertEmail(event.currentTarget.value));
  }

  function handleSetAlert() {
    // dispatch(
    //   updateVisitorJobAlertDialogDetails({
    //     keyword: title ?? "",
    //   })
    // );
    // dispatch(updateVisitorJobAlertDialogOrigin("single-job-page"));
    // dispatch(updateShowJobAlertDialog(true));
    dispatch(
      updateJobAlertCreateDialogWithKeyword({
        keyword: title ?? "",
        origin: "single-job-page",
      })
    );
    dispatch(updateJobAlertCreateDialog(true));
    sethideContainer(true);
  }

  function handleClose() {
    sethideContainer(true);
  }

  return (
    <AlertContainer sx={hideContainer && { display: "none" }}>
      <BoxStyled typeof="left">
        <BellIconStyled />
        <TextStyled>Get notified on similar new jobs!</TextStyled>
      </BoxStyled>
      <BoxStyled typeof="right">
        <InputBaseStyled
          id="email"
          placeholder="Email"
          onChange={onInputUpdate}
          size="small"
          startAdornment={
            <InputAdornmentStyled position="start">
              <EnvelopeIconStyled />
            </InputAdornmentStyled>
          }
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleSetAlert();
            }
          }}
        ></InputBaseStyled>
        <ButtonStyled variant="contained" onClick={handleSetAlert}>
          Set Alert
        </ButtonStyled>
      </BoxStyled>
      <CloseIconStyled onClick={handleClose} />
    </AlertContainer>
  );
}

export default JobAlertSticky;
